import React, { Fragment } from 'react'
import Simplert from 'react-simplert'
import Helmet from 'react-helmet'
import axios from 'axios'
import Input from '../../../components/newInput/input'
// import {FileInput} from '../../../components/fileInput/fileInput'
import Loading from '../../../components/loading/loading'
import Button from '../../../components/newButton/button'
import { Mutation } from "react-apollo"
import { UpdateAddress, UpdateDescription, UpdatePhone } from '../../../queries/player'
import { GraphQLClient } from 'graphql-request'
import Modal from '../../../components/Modal/modal'
import { endpoint } from "../../../queries/endpoint"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import PasswordMeter from '../../../components/PassworMeter/passwordmeter'
import ErrorM from '../../../components/ErrorMessange/errormenssage'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/lib/ReactCrop.scss'
// import Alert from 'react-bootstrap/Alert'
// import PhotoZoom from '../../../components/photoZoom/photoZoom'
import './dataUser.scss'
import LoadingProgress from '../../../components/loadingprogress/loadingprogress'

export default class anuncios extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            value: '',
            submitOK: false,
            zipcode: '',
            street: '',
            neighborhood: '',
            city: '',
            state: '',
            showAlert: false,
            typeAlert: '',
            titleAlert: '',
            messageAlert: '',
            onClose: null,
            beProf: false,
            show: false,
            customCloseBtnText: 'Fechar',
            customCloseBtnClass: 'buttonnot', // colocar cor roxa
            passwordok: false,
            passwordErr: null,
            addressOk: false,
            descriptionOk: false,
            phoneOk: false,
            skills: [],
            fileUp: {},
            loading: false,
            showModal: false,
            imgSrc: '',
            src: null,
            blob: null,
            crop: {
                unit: "%",
                width: 100,
                aspect: 1 / 1
            },
            loadingprogress: false,
            now: 0
        }

        this.form = {}

        // console.log(this.form)
        // this.setInput = event => {
        //     this.setState({ value: event.target.value });
        //     this.form[`${event.target.name}`] = event.target.value
        //     console.log(this.form[`${event.target.name}`], event.target.name)
        //     return this.state.value
        // } //_setInput

        this.getZipcode = async e => {
            const zipcode = e.target.value.replace("-", "");

            if (zipcode.length < 8 && !zipcode.match(/_/)) return false;
            try {
                this.setState({ getAddress: true });
                const address = await axios.get(`https://viacep.com.br/ws/${zipcode}/json/`, {})
                this.setState({
                    zipcode: address.data.cep,
                    street: address.data.logradouro,
                    neighborhood: address.data.bairro,
                    city: address.data.localidade,
                    state: address.data.uf
                })
                this.form['zipcode'] = this.state.zipcode
                this.form['street'] = this.state.street
                this.form['complement'] = this.state.complement
                this.form['neighborhood'] = this.state.neighborhood
                this.form['city'] = this.state.city
                this.form['state'] = this.state.state
                this.setState({ getAddress: false })
                document.getElementsByName('number').focus()
            } catch (e) {
                console.log("# zipcode error", e);
                this.setState({ getAddress: false })
            }
        }; //_getZipcode

        this.blurEmailPass = () => {
            this.setState({ showAlert: false, passErr: null })
            if (this.form.email !== undefined && this.form.email.length > 5) {
                if (this.form.email.includes('@') && this.form.email.split("@")[1].includes('.')) {
                    const emailValid = this.form.email.split(" ")[0]
                    this.form.email = emailValid

                    const cache = JSON.parse(sessionStorage.getItem('OITO'))

                    const client = new GraphQLClient(endpoint, {
                        headers: {
                            Authorization: `Bearer ${cache.token}`,
                        },
                    })

                    client.request(`
                    {
                    allUsers(filter: {
                        email: "${emailValid.toString()}"
                    }){
                        id
                        email
                        name
                        document
                    }
                    }
            `).then(
                        res => {
                            if (res.allUsers.length > 0) {
                                if (res.allUsers[0].email !== cache.user.email) {
                                    this.setState({
                                        passErr: <ErrorM color="danger" content='Este e-mail já está cadastrado.' />,
                                        emailPok: false,
                                    })
                                } else {
                                    this.setState({ emailPok: true, emailErr: null })
                                }
                            }
                        }
                    ).catch(er => console.log(er))

                } else {
                    this.setState({
                        passErr: <ErrorM color="danger" content='E-mail inválido. Por favor, digite novamente. Ex.: jose@email.com' />,
                        emailPok: false,
                    })
                }
            } else {
                this.setState({ emailok: false, spinneremail: false, emailErr: null })
            }
        }

        this.blur = () => {
            this.setState({ showAlert: false, addressOk: false })


            if (!this.form.phone) {
                this.setState({
                    phoneOk: false,
                    showAlert: true,
                    typeAlert: 'error',
                    titleAlert: 'Campo obrigatório!',
                    messageAlert: 'É obrigatório ter um telefone válido.'
                })
            } else if (this.form.phone && !this.form.phone.match(/_/)) {
                this.setState({ phoneOk: true })
            }

            if (this.form.street &&
                this.form.zipcode &&
                this.form.number &&
                this.form.neighborhood &&
                this.form.city &&
                this.form.state) {
                    this.setState({ addressOk: true })
                }

        }

        this.saveAddress = UpdateAddress => {
            this.setState({ showAlert: false, loading: true })
            UpdateAddress({
                variables: {
                    street: this.form.street,
                    zipcode: this.form.zipcode,
                    number: this.form.number,
                    complement: this.form.complement,
                    neighborhood: this.form.neighborhood,
                    city: this.form.city,
                    state: this.form.state,
                    country: this.form.country,
                }
            }).then(
                res => {
                    const cache = JSON.parse(sessionStorage.getItem('OITO'))
                    console.log("atualizando o storage")
                    const userAuth = {
                        token: cache.token,
                        user: cache.user
                    }

                    sessionStorage.setItem('OITO', JSON.stringify(userAuth))

                    this.sendNotification(res.data.updatePlayer.id)

                }
            )
        } //_nextStep

        this.saveDescription = UpdateDescription => {
            this.setState({ showAlert: false, loading: true })
            UpdateDescription({
                variables: {
                    description: this.form.description,
                }
            }).then(
                res => {
                    const cache = JSON.parse(sessionStorage.getItem('OITO'))
                    console.log("atualizando o storage")
                    const userAuth = {
                        token: cache.token,
                        user: cache.user
                    }

                    sessionStorage.setItem('OITO', JSON.stringify(userAuth))

                    // this.sendNotification(res.data.updatePlayer.id)
                }
            )
        } //_nextStep

        this.savePhone = UpdatePhone => {
            this.setState({ showAlert: false, loading: true })
            UpdatePhone({
                variables: {
                    phone: this.form.phone,
                    phoneverif: false,
                }
            }).then(
                res => {
                    const cache = JSON.parse(sessionStorage.getItem('OITO'))
                    console.log("atualizando o storage")
                    const userAuth = {
                        token: cache.token,
                        user: cache.user
                    }

                    sessionStorage.setItem('OITO', JSON.stringify(userAuth))
                    this.setState({ loading: false })
                    window.location.href = `/verificartelefone`

                }
            )
        } //_nextStep

        this.blurPassword = () => {
            this.setState({ showAlert: false, passwordErr: null, passwordok: false })
            var regex = /^(?=(?:.*?[0-9]){2})(?=(?:.*?[a-zA-Z]){2})(?!.*\s)[0-9a-zA-Z!@#$%;*(){}_+^&]*$/;

            if (this.form.password) {
                if (this.form.password.length >= 8) {
                    if (regex.exec(this.form.password)) {
                        this.setState({ passwordok: true, passwordErr: null })
                    } else {
                        this.setState({
                            passwordok: false,
                            passwordErr: <ErrorM color="danger" content='A senha deve ter, no mínimo, 2 números e 2 letras.' />
                        })
                    }
                } else {
                    this.setState({
                        passwordok: false,
                        passwordErr: <ErrorM color="danger" content='A senha deve ter, no mínimo, 8 caracteres.' />
                    })
                }
            }
        }

        this.showModal = e => {
            this.setState({
                show: !this.state.show
            });
        }

        this.newPassword = () => {
            this.setState({ loadingP: true })
            const cache = JSON.parse(sessionStorage.getItem('OITO'))

            const client = new GraphQLClient(endpoint, {
                headers: {
                    Authorization: `Bearer ${cache.token}`,
                },
            })

            client.request(`
                    mutation{
                        updateUserPassword(
                            assword: "${this.form.password}"
                        )}`).then(
                res => {
                    console.log(res)
                    if (res) {
                       //enviar modal de confirmacao
                    this.setState({
                        show: false,
                        loadingP: false,
                        showAlert: true,
                        typeAlert: 'success',
                        titleAlert: 'Senha alterada com sucesso.',
                        messageAlert: 'Guarde bem sua nova senha, você irá usa-la para se conectar de novo.',
                        onClose: () => window.location.reload()
                    }) 
                    } else {
                        this.setState({
                            show: false,
                            loadingP: false,
                            showAlert: true,
                            typeAlert: 'error',
                            titleAlert: 'Erro ao salvar a senha.',
                            messageAlert: 'Aconteceu algo de errado ao salvar sua senha. Tente novamente.',
                            onClose: () => window.location.reload()
                        }) 
                    }
                    
                }
            )
        }
    }

    openModal = e => {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    onSelectFile = e => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener("load", () =>
                this.setState({ src: reader.result })
            );
            reader.readAsDataURL(e.target.files[0]);
            this.openModal()
        }
    };

    // If you setState the crop in here you should return false.
    onImageLoaded = image => {
        this.imageRef = image;
    };

    onCropComplete = crop => {
        this.makeClientCrop(crop)
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                "newFile.jpeg"
            );
            this.setState({ croppedImageUrl });
        }
    }

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        )

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    //reject(new Error('Canvas is empty'));
                    console.error("Canvas is empty");
                    return;
                }
                blob.name = fileName;
                window.URL.revokeObjectURL(this.fileUrl);
                this.fileUrl = window.URL.createObjectURL(blob);
                resolve(this.fileUrl);
                this.setState({ blob })
            }, "image/jpeg");
        });
    }

    saveImg() {
        this.setState({ loadingprogress: true, showModal: !this.state.showModal })

        const cache = JSON.parse(sessionStorage.getItem('OITO'))

        if (this.state.blob !== undefined || this.state.blob !== null ) {

        const file = this.state.blob
        const fileName = this.state.blob.name;   // Like : abc.jpeg
        const path_splitted = fileName.split('.')
        const extension = path_splitted.pop()
        const newName = cache.user.player.id + '.' + extension

        const myNewFile = new File([file], newName, { type: file.type })

        let data = new FormData();
        data.append('data', myNewFile)

        axios.post('https://api.graph.cool/file/v1/oitoapi', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${cache.token}`
            },
            onUploadProgress: ProgressEvent => {
                this.setState({
                    now: parseInt(ProgressEvent.loaded / ProgressEvent.total * 100),
                })
            }
        })
            .then(res => {

                const cache = JSON.parse(sessionStorage.getItem('OITO'))

                // console.log(res)
                const client = new GraphQLClient(endpoint, {
                    headers: {
                        Authorization: `Bearer ${cache.token}`,
                    },
                })

                // console.log(data.location)

                client.request(`
                        mutation{
                            updatePlayer(
                                id: "${cache.user.player.id}",
                          photoId: "${res.data.id}"
                          ){
                            id
                            name
                            birthday
                            phone
                            type
                            role
                            email
                            phoneverif
                            description
                            photo
                            document
                            address {
                              city
                              state
                              street
                              zipcode
                              number
                              complement
                              neighborhood
                              country
                            }                                  
                          }
                          }
                    `).then(
                    res => {
                        // console.log(res)
                        //atualiza session storage
                        const cache = JSON.parse(sessionStorage.getItem('OITO'))
                        console.log("atualizando o storage")
                        const userAuth = {
                            token: cache.token,
                            user: cache.user
                        }
                        sessionStorage.setItem('OITO', JSON.stringify(userAuth))

                        this.setState({
                            loadingprogress: false,
                            showAlert: true,
                            showModal: false,
                            typeAlert: 'success',
                            titleAlert: 'Foto atualizada com sucesso!',
                            onClose: () => window.location.reload()
                        })
                    }
                )
            })
            .catch((err) => {
                console.log(err)
                this.setState({
                    loadingprogress: false,
                    showAlert: true,
                    showModal: false,
                    typeAlert: 'error',
                    titleAlert: 'Algo de errado aconteceu. Por favor, tente novamente.',
                    onClose: () => window.location.reload()
                })
            })
        } else {
            this.setState({
                loadingprogress: false,
                showAlert: true,
                showModal: false,
                typeAlert: 'error',
                titleAlert: 'Algo de errado aconteceu. Por favor, tente novamente. Selecione uma imagem válida ou troque o nome do arquivo.',
            })
        }
    }

    render() {
        const { crop, src } = this.state;

        const cache = JSON.parse(sessionStorage.getItem('OITO'))
        // console.log(cache)
        if (cache) {
            // console.log("cache ok")
            if (cache.user.address && cache.user.birthday && cache.user.phoneverif) {
                // console.log("if do completar cadastro")
                if (cache.user.address.city) {
                    // console.log('this.form')
                    this.form['id'] = cache.user.id
                    this.form['name'] = cache.user.name
                    this.form['type'] = cache.user.type
                    this.form['skills'] = cache.user.skills
                    this.form['description'] = cache.user.description
                    this.form['phone'] = cache.user.phone
                    this.form['phoneverif'] = cache.user.phoneverif
                    this.form['type'] = cache.user.type
                    this.form['street'] = cache.user.address.street
                    this.form['zipcode'] = cache.user.address.zipcode
                    this.form['number'] = cache.user.address.number
                    this.form['complement'] = cache.user.address.complement
                    this.form['neighborhood'] = cache.user.address.neighborhood
                    this.form['city'] = cache.user.address.city
                    this.form['state'] = cache.user.address.state
                    this.form['country'] = cache.user.address.country
                    this.form['email'] = cache.user.email
                }
            } else if (cache.user.document === null || !cache.user.birthday === null || cache.user.address === null) {
                // console.log("completar cadastro")
                if (!this.state.showAlert) this.setState({
                    showAlert: true,
                    typeAlert: 'error',
                    titleAlert: 'Você não completou seu cadastro!',
                    messageAlert: 'Para criar um anúncio é necessario finalizar o cadastro.',
                    onClose: () => window.location.href = '/perfil/completarcadastro'
                })
                window.setTimeout(window.location.href = '/perfil/completarcadastro', 2000)
            } else {
                // console.log("verifica phone")
                window.location.href = `/verificartelefone`
            }

        } else {
            if (!this.state.showAlert) this.setState({
                showAlert: true,
                typeAlert: 'error',
                titleAlert: 'Você não está logado!',
                messageAlert: 'Entre ou cadastre-se. É gratuito!',
                onClose: () => window.location.href = '/login'
            })
            window.setTimeout(window.location.href = '/login', 2000)
        }


        return (
            <Fragment>

                <Helmet title='Oito - Atualizar perfil'>
                    <meta name="title" content="Oito.app | Altere ou complete dados do seu perfil em Oito.app" />
                    <meta name="description" content="Complete seu cadastro com informações pessoais e profissionais. Altere dados importantes, caso necessário, e mantenha seu perfil sempre atualizado." />
                    <meta name="keywords" content="Dados, Profissionais, Clientes" />
                    <meta name="robots" content="index, follow" />
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                    <meta name="language" content="Portuguese" />
                    <meta name="revisit-after" content="1 days" />
                </Helmet>

                <Simplert
                    showSimplert={this.state.showAlert}
                    type={this.state.typeAlert}
                    title={this.state.titleAlert}
                    message={this.state.messageAlert}
                    customCloseBtnText={this.state.customCloseBtnText}
                    customCloseBtnClass={this.state.customCloseBtnClass}
                    onClose={this.state.onClose}
                />

                <Modal show={this.state.showModal} title={"Recorte sua foto"} onClose={this.openModal} >
                    {this.state.loading ? <Loading /> :
                        <div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <div style={{ maxWidth: 550 }}>
                                    {src && (
                                        <ReactCrop
                                            src={src}
                                            crop={crop}
                                            onImageLoaded={this.onImageLoaded}
                                            onComplete={this.onCropComplete}
                                            onChange={this.onCropChange}
                                        />
                                    )}
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button onClick={() => this.saveImg()} name='Salvar'
                                    type='button' />
                            </div>
                        </div>}
                </Modal>

                <Modal show={this.state.show} onClose={this.showModal} title='Alterar e-mail ou senha'>
                                <p>Ao alterar e-mail ou senha suas credenciais para entrar na Oito também serão alteradas.</p>
                                <p>Então, guarde-as com carinho.</p>
                                {this.state.passErr}
                                <form id="newPassForm">
                                    <Input name={'email'} type={'email'} placeholder={'E-mail'} onInput={this.setInput} value={this.form.email} onKeyUp={this.blurEmailPass} required={true} />
                                    <OverlayTrigger
                                        placement='right'
                                        overlay={<Tooltip id='password'>
                                            Para criar uma senha segura você deve escolher, no mínimo, 8 caracteres, usando letras e números.
                      </Tooltip>} >
                                        <Input name={'password'} type={'password'} placeholder={'Senha com mínimo de 8 caracteres.'} onInput={this.setInput} minlength={8} required={true} onKeyUp={this.blurPassword} />
                                    </OverlayTrigger>
                                    <PasswordMeter password={this.form.password} />
                                    {this.state.passwordErr}
                                    {!this.state.loadingP ?
                                        <Button type="button" onClick={this.newPassword} name="Entrar" disabled={(this.form.email && this.state.passwordok) ? false : true} />
                                        : <Loading />}
                                </form>
                            </Modal>

                {this.state.loadingprogress ? <LoadingProgress now={this.state.now} arq={this.state.arq} arqtotal={this.state.arqtotal} /> : null}

                <div className="col-xs-12" style={{ maxWidth: '980px'}}>
                        <div className="form-register-box row center-xs">
                            <div className="form-title col-xs-12">
                                <h3>Oi, <span>{this.form.name}</span>. Atualize seus dados!</h3>
                                {JSON.parse(sessionStorage.getItem('OITO')) ? null : window.location.href = '/login'}
                            </div>

                            <div className="form-container col-xs-12">
                                {this.state.loading ? <Loading /> :
                                    <div className="row center-xs bottom-xs">
                                        <div className="ButtonEdit col-xs-12">
                                                <Button type="button" onClick={() => this.setState({ show: !this.state.show })} name="Alterar e-mail ou senha" />
                                                <label>Trocar foto de perfil<input id="buttonUploadImg" style={{ display: 'none' }} label='Alterar imagem de perfil' type='file' accept='image/*' onChange={this.onSelectFile} /></label>
                                        </div>

                                        <form id="myform" className="col-xs-12" style={{ marginTop: '15px' }}>
                                            <div className="row center-xs">
                                                <div className="col-xs-12 input-phone">
                                                    <Input name="phone" label="Telefone" placeholder="Celular. Ex.: (xx) xxxxx-xxxx" type="text" defaultValue={this.form.phone} mask="(99) 99999-9999" onBlur={this.blur} onInput={(e) => this.form.phone = e.target.value} />
                                                    <OverlayTrigger
                                                        placement='right'
                                                        overlay={<Tooltip id="pqphone">A Oito necessita de um número de telefone válido para facilitar o contato entre clientes e prestadores de serviço.</Tooltip>} >
                                                        <i className="fas fa-info infoIcon"></i>
                                                    </OverlayTrigger>
                                                    <div className="col-xs-12">
                                                        {this.state.phoneOk ? <Mutation mutation={UpdatePhone}>
                                                        {(UpdatePhone, { loading, error }) => {
                                                            if (loading) return <Loading />
                                                            if (error) console.log(error.message)
                                                            return <Button type="submit" onClick={() => this.savePhone(UpdatePhone)} name='Salvar telefone' />
                                                        }}
                                                    </Mutation> : null}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row around-xs">
                                                <div className="info-button col-xs-12">
                                                    <Input name="description" label="Descrição" placeholder="Faça uma breve descrição sua." type="text" defaultValue={this.form.description} onInput={(e) => this.form.description = e.target.value} onChange={() => this.setState({ descriptionOk: true })} maxlength={140} />
                                                    <OverlayTrigger
                                                        placement='right'
                                                        overlay={<Tooltip id="pqdescription">Fale um pouco de você. É aqui que você conquista seus clientes.</Tooltip>} >
                                                        <i className="fas fa-info infoIcon"></i>
                                                    </OverlayTrigger>
                                                </div>
                                                {this.state.descriptionOk ? <Mutation mutation={UpdateDescription}>
                                                    {(UpdateDescription, { loading, error }) => {
                                                        if (loading) return <Loading />
                                                        if (error) console.log(error.message)
                                                        return <Button type="submit" onClick={() => this.saveDescription(UpdateDescription)} name='Salvar descrição' />
                                                    }}
                                                </Mutation> : null}
                                            </div>


                                            <div className="address-form row center-xs">
                                                {/* colocar esse titulo numa linha sozinha */}
                                                
                                                <div className="col-xs-12">
                                                <h4>Endereço</h4>
                                                    {this.state.zipErr}
                                                </div>
                                                <div className="col-xs-12 col-sm-4 cep-input">
                                                    <Input onBlur={this.blur} onInput={(e) => this.getZipcode(e)}
                                                    mask="99999-999"
                                                        name="zipcode" label="CEP" placeholder="CEP. Ex.: 00000-000" type="text" defaultValue={this.form.zipcode} required />
                                                    <OverlayTrigger
                                                        placement='right'
                                                        overlay={<Tooltip id="pqaddress">A Oito exige que você cadastre um endereço válido para manter a integridade da nossa plataforma.</Tooltip>} >
                                                        <i className="fas fa-info"></i>
                                                    </OverlayTrigger>
                                                </div>

                                                {this.getAddress ? (
                                                    <div className="loadingGetAddress">
                                                        <i className="fas fa-spinner rotate-spin" />
                                                    </div>
                                                ) : null}

                                                <div className="col-xs-12">
                                                    <Input onInput={(e) => this.form.street = e.target.value} onChange={this.blur}
                                                        name="street" defaultValue={this.form.street} label="Endereço" placeholder="Rua, Avenida ou Logradouro." type="text" required />
                                                </div>

                                                <div className="col-xs-12 col-sm-3">
                                                    <Input onInput={(e) => this.form.number = e.target.value} onChange={this.blur} onKeyUp={this.blur}
                                                        name="number" label="Número" placeholder="Número. Ex.: 00" type="text" defaultValue={this.form.number} required />
                                                </div>

                                                <div className="col-xs-12 col-sm-4">
                                                    <Input onInput={(e) => this.form.complement = e.target.value} onChange={this.blur}
                                                        name="complement" label="Complemento" placeholder="Complemento. Ex.: Apto 1101" type="text" defaultValue={this.form.complement} />
                                                </div>

                                                <div className="col-xs-12 col-sm-5">
                                                    <Input onInput={(e) => this.form.neighborhood = e.target.value} onChange={this.blur}
                                                        name="neighborhood" defaultValue={this.form.neighborhood} label="Bairro" placeholder="Bairro" type="text" required />
                                                </div>

                                                <div className="col-xs-12 col-sm-8">
                                                    <Input onChange={this.blur}
                                                        name="city" value={this.form.city} label="Cidade" placeholder="Cidade" type="text" required />
                                                </div>

                                                <div className="col-xs-12 col-sm-4">
                                                    <Input onChange={this.blur}
                                                        name="state" value={this.form.state} label="Estado" placeholder="Estado" type="text" required />
                                                </div>

                                                <div className="col-xs-12 register-two-buttons">
                                                    {this.state.addressOk ? <Mutation mutation={UpdateAddress}>
                                                        {(UpdateAddress, { loading, error }) => {
                                                            if (loading) return <Loading />
                                                            if (error) console.log(error.message)
                                                            return <Button type="submit" onClick={() => this.saveAddress(UpdateAddress)} name="Salvar endereço" />
                                                        }}
                                                    </Mutation> : null}
                                                </div>
                                            </div>
                                        </form>
                                    </div>}
                            </div>
                        </div>
                </div>
            </Fragment>
        )
    }
}
